module.exports = __webpack_public_path__ + "static/media/co2_icon.3c98cff7.svg";